export default __webpack_public_path__ + "static/media/devmedia-logo3.dba9be7c.png";